module.exports = __webpack_public_path__ + "img/info-image.be7228a9.jpeg";